import React, { useState } from "react";
import Sidebar from "../../components/Super Admin/SideBar/Sidebar";
import TopTabs from "../../components/Super Admin/TopBar/TopbarCoreFunctions";
import QavachCenterTable from "../../components/Super Admin/Core Functions/QavachCenterTable";
import CampCenterTable from "../../components/Super Admin/Core Functions/CampCenterTable";
import "../../css/CentersPage.css";

const CentersPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState<"qavach" | "camp">("qavach");

  return (
    <>
        <TopTabs />

        {/* Toggle Buttons */}
        <div className="center-toggle">
          <button
            className={`toggle-btn ${activeTab === "qavach" ? "active" : ""}`}
            onClick={() => setActiveTab("qavach")}
          >
            Qavach Center
          </button>
          <button
            className={`toggle-btn ${activeTab === "camp" ? "active" : ""}`}
            onClick={() => setActiveTab("camp")}
          >
            Camp Center
          </button>
        </div>

        {/* Render Tables */}
        <div className="center-table-container">
          {activeTab === "qavach" ? <QavachCenterTable /> : <CampCenterTable />}
        </div>
        </>
  );
};

export default CentersPage;
